import { render } from "./UpdateRequiredModal.vue?vue&type=template&id=ac406314&scoped=true"
import script from "./UpdateRequiredModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateRequiredModal.vue?vue&type=script&setup=true&lang=js"

import "./UpdateRequiredModal.vue?vue&type=style&index=0&id=ac406314&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac406314"],['__file',"src/core/main/UpdateRequiredModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac406314"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac406314', __exports__)) {
    console.log('reload')
    api.reload('ac406314', __exports__)
  }
  
  module.hot.accept("./UpdateRequiredModal.vue?vue&type=template&id=ac406314&scoped=true", () => {
    console.log('re-render')
    api.rerender('ac406314', render)
  })

}


export default __exports__